import { useState } from 'react'
import { useAuthStore } from '../../contexts/authStore'
import ProfileTab from '../account/ProfileTab'
import SecurityTab from '../account/SecurityTab'
import TwoFactorTab from '../account/TwoFactorTab'
import SessionsTab from '../account/SessionsTab'

const tabs = [
  { id: 'profile', label: 'Profil' },
  { id: 'security', label: 'Sicherheit' },
  { id: '2fa', label: 'Zwei-Faktor-Auth' },
  { id: 'sessions', label: 'Sitzungen' },
] as const

export default function AccountPage() {
  const [activeTab, setActiveTab] = useState<(typeof tabs)[number]['id']>('profile')
  const { user } = useAuthStore()

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 24 }}>
      <div>
        <h1 style={{ fontSize: 24, margin: '0 0 6px' }}>Kontoeinstellungen</h1>
        <p className="wc-muted" style={{ fontSize: 14, margin: 0 }}>
          Verwalten Sie Ihr Profil, Sicherheitseinstellungen und mehr
        </p>
      </div>

      <div className="wc-card wc-elev-sm">
        <h3 className="wc-card-title" style={{ margin: 0 }}>Kontoinformationen</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16, marginTop: 4 }}>
          <div>
            <div className="wc-muted" style={{ fontSize: 12, marginBottom: 2 }}>E-Mail</div>
            <div style={{ fontSize: 14 }}>{user?.email}</div>
          </div>
          <div>
            <div className="wc-muted" style={{ fontSize: 12, marginBottom: 2 }}>Benutzertyp</div>
            <div style={{ fontSize: 14 }}>Administrator</div>
          </div>
        </div>
      </div>

      <div className="wc-seg" role="tablist" style={{ display: 'flex', width: '100%' }}>
        {tabs.map((tab) => (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-pressed={activeTab === tab.id}
            onClick={() => setActiveTab(tab.id)}
            className="wc-seg-opt"
            style={{ flex: 1, justifyContent: 'center' }}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === 'profile' && <ProfileTab />}
      {activeTab === 'security' && <SecurityTab />}
      {activeTab === '2fa' && <TwoFactorTab />}
      {activeTab === 'sessions' && <SessionsTab />}
    </div>
  )
}
